import {httpGet, httpPost} from '@/request';

//获取展馆信息
function getVenusInfo(params) {
    return httpGet("/tenant-venues/app/venues/venues/info",params)
}

//获取展馆列表
function getVenuesPage(params) {
    return httpPost("/tenant-venues/app/venues/venues/page",params)
}

//获取基地省市联动
function getVenuesPcc() {
    return httpGet("/tenant-venues/app/venues/venues/pcc")
}

//获取展馆类型
function getVenuesType() {
    return httpGet("/tenant-venues/app/venues/venues-type/list")
}

//展馆打卡
function venuesClock(params) {
    return httpPost("/tenant-venues/app/venues/clock/clock",params)
}


export {
    getVenusInfo,
    getVenuesPage,
    getVenuesPcc,
    getVenuesType,
    venuesClock
}
